import HydrotherapyIcon from './HydrotherapyIcon';
import WeeklySaleIcon from './WeeklySaleIcon';
import PeopleIcon from './PeopleIcon';

const index = {
  'hydrotherapy-icon': HydrotherapyIcon,
  'weekly-sale-icon': WeeklySaleIcon,
  'people-icon': PeopleIcon
};

export default index;
